var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass:
        "canvas::editor-admin-Gallery h-full w-full flex flex-col relative",
    },
    [
      _vm.canvasVersion.canvas_blocks.length == 0
        ? _c(
            "svg",
            {
              staticClass: "absolute w-40 pointer-events-none -mr-4 arrow",
              attrs: {
                xmlns: "http://www.w3.org/2000/svg",
                viewBox: "0 0 200.26 68.42",
              },
            },
            [
              _c("path", {
                attrs: {
                  d: "M6.19,9.4Q4.9,7.87,3.62,6.3L5.18,5Q6.44,6.6,7.72,8.11Z",
                },
              }),
              _vm._v(" "),
              _c("path", {
                attrs: {
                  d: "M139.15,68.42q-2,0-4,0l0-2q4.09.08,8.16,0l0,2Q141.29,68.42,139.15,68.42ZM128,68.13c-2.75-.15-5.52-.35-8.22-.61l.19-2c2.68.25,5.42.45,8.14.6Zm22.65,0-.11-2c2.7-.14,5.44-.33,8.15-.58l.18,2C156.12,67.78,153.36,68,150.63,68.12ZM166,66.79l-.24-2c2.69-.32,5.41-.7,8.09-1.11l.31,2C171.48,66.09,168.73,66.47,166,66.79Zm-53.43-.08c-2.73-.36-5.47-.78-8.15-1.25l.35-2c2.64.47,5.36.88,8.06,1.24Zm68.69-2.25-.37-2c2.66-.49,5.35-1,8-1.62l.43,2C186.68,63.41,184,64,181.28,64.46Zm-83.92-.4c-2.68-.58-5.38-1.24-8-1.94l.52-1.93c2.6.69,5.27,1.34,7.93,1.92Zm-15-3.94c-2.63-.82-5.26-1.71-7.81-2.65l.69-1.88c2.53.93,5.12,1.81,7.72,2.62ZM67.87,54.84c-2.54-1.06-5.07-2.19-7.53-3.37l.86-1.8C63.63,50.83,66.13,52,68.64,53Zm-14-6.62c-2.41-1.29-4.82-2.66-7.17-4.07l1-1.71c2.32,1.4,4.71,2.75,7.08,4ZM40.62,40.27c-2.28-1.52-4.55-3.12-6.74-4.75l1.19-1.6c2.17,1.62,4.41,3.19,6.66,4.69ZM28.19,31.08c-2.11-1.73-4.22-3.54-6.25-5.38l1.34-1.48c2,1.82,4.09,3.61,6.18,5.31ZM16.69,20.75c-1.94-1.91-3.86-3.91-5.73-5.93l1.47-1.35c1.84,2,3.74,4,5.66,5.86Z",
                },
              }),
              _vm._v(" "),
              _c("path", {
                attrs: {
                  d: "M196.38,61.16l-.49-1.94q1.94-.49,3.85-1l.52,1.93Q198.33,60.67,196.38,61.16Z",
                },
              }),
              _vm._v(" "),
              _c("polygon", {
                attrs: { points: "1.39 9.88 0 0 9.24 3.73 1.39 9.88" },
              }),
            ]
          )
        : _vm._e(),
      _vm._v(" "),
      _c("div", { staticClass: "h-full overflow-auto pt-4 pl-5" }, [
        _c("div", { staticClass: "flex items-center" }, [
          _vm._m(0),
          _vm._v(" "),
          _c(
            "div",
            {
              staticClass:
                "relative z-0 inline-flex shadow-sm rounded-md ml-auto mr-5 categories",
            },
            _vm._l(_vm.activeGalleryData, function (category, key) {
              return _c(
                "button",
                {
                  key: category.id,
                  staticClass:
                    "-ml-px relative inline-flex items-center px-4 py-2 border border-gray-300 bg-white text-sm font-medium text-gray-700 hover:bg-gray-50 focus:z-10 focus:outline-none focus:ring-1 focus:ring-indigo-500 focus:border-indigo-500",
                  class: {
                    "bg-indigo-50": _vm.activeCategory === category,
                    "rounded-r-md":
                      key === Object.keys(_vm.activeGalleryData).length - 1,
                    "rounded-l-md": key === 0,
                  },
                  attrs: { type: "button" },
                  on: {
                    click: function ($event) {
                      _vm.activeCategory = category
                    },
                  },
                },
                [
                  _vm._v(
                    "\n                    " +
                      _vm._s(category.label) +
                      "\n                "
                  ),
                ]
              )
            }),
            0
          ),
        ]),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "mt-5 pr-5" },
          _vm._l(_vm.sections, function (section) {
            return _c("div", {}, [
              Object.keys(_vm.sections).length > 1
                ? _c(
                    "div",
                    { staticClass: "text-xl text-indigo-500 mb-5 text-center" },
                    [
                      _vm._v(
                        _vm._s(
                          section.name === "undefined"
                            ? "Geen categorie"
                            : section.name
                        )
                      ),
                    ]
                  )
                : _vm._e(),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "blocks grid grid-cols-3 gap-6 pb-10" },
                _vm._l(section.blocks, function (block) {
                  return _c(
                    "div",
                    { staticClass: "flex hover:opacity-50 transition-all" },
                    [
                      _c(
                        "button",
                        {
                          staticClass:
                            "col-span-1 flex flex-col text-center bg-white rounded-lg shadow divide-y divide-gray-200 h-80 w-full",
                          attrs: {
                            type: "button",
                            draggable: "true",
                            title: block.id,
                          },
                          on: {
                            dragstart: function ($event) {
                              return _vm.onDragStart(block)
                            },
                            dragend: _vm.onDragEnd,
                            click: function ($event) {
                              return _vm.addBlock(block)
                            },
                          },
                        },
                        [
                          _c(
                            "div",
                            {
                              staticClass:
                                "flex-1 flex flex-col px-2 py-5 mx-auto w-full",
                            },
                            [
                              (block.icon ? block.icon.original : false)
                                ? _c(
                                    "div",
                                    { staticClass: "h-32 flex items-center" },
                                    [
                                      _c("img", {
                                        staticClass: "h-full mx-auto",
                                        attrs: {
                                          src: _vm.convertSvgToImageSrc(
                                            block.icon.original
                                          ),
                                          draggable: "false",
                                          title: block.id,
                                        },
                                      }),
                                    ]
                                  )
                                : block.icon
                                ? _c(
                                    "div",
                                    { staticClass: "h-32 flex items-center" },
                                    [
                                      _c("img", {
                                        attrs: {
                                          src: block.icon,
                                          draggable: "false",
                                          title: block.id,
                                        },
                                      }),
                                    ]
                                  )
                                : block.meta.icon
                                ? _c(
                                    "div",
                                    {
                                      staticClass:
                                        "h-32 flex items-center relative icon",
                                    },
                                    [
                                      _c(
                                        "svg",
                                        {
                                          attrs: {
                                            xmlns: "http://www.w3.org/2000/svg",
                                            width: "457.361",
                                            height: "457.361",
                                            viewBox: "0 0 457.361 457.361",
                                          },
                                        },
                                        [
                                          _c(
                                            "g",
                                            {
                                              attrs: {
                                                id: "Group_37",
                                                "data-name": "Group 37",
                                                transform:
                                                  "translate(-1781 -3305)",
                                              },
                                            },
                                            [
                                              _c("path", {
                                                attrs: {
                                                  id: "Path_20",
                                                  "data-name": "Path 20",
                                                  d: "M371.605,457.361H85.755A85.75,85.75,0,0,1,0,371.605V85.755A85.75,85.75,0,0,1,85.755,0h285.85a85.75,85.75,0,0,1,85.755,85.755v285.85A85.75,85.75,0,0,1,371.605,457.361Z",
                                                  transform:
                                                    "translate(1781 3305)",
                                                  fill: "#d8d8d8",
                                                },
                                              }),
                                            ]
                                          ),
                                        ]
                                      ),
                                      _vm._v(" "),
                                      _c("i", {
                                        staticClass:
                                          "absolute left-0 right-0 text-4xl",
                                        class: block.meta.icon,
                                      }),
                                    ]
                                  )
                                : _c(
                                    "div",
                                    { staticClass: "h-32 flex items-center" },
                                    [
                                      _c("img", {
                                        staticClass: "h-full mx-auto",
                                        attrs: {
                                          src: "/vendor/galaxy/canvas/img/editor/admin/question-mark.svg",
                                          draggable: "false",
                                          title: block.id,
                                        },
                                      }),
                                    ]
                                  ),
                              _vm._v(" "),
                              _c(
                                "h3",
                                {
                                  staticClass:
                                    "mt-6 text-gray-900 text-base font-medium truncate w-full mx-auto",
                                  attrs: { title: block.meta.name },
                                },
                                [_vm._v(_vm._s(block.meta.name))]
                              ),
                              _vm._v(" "),
                              _c(
                                "dl",
                                {
                                  staticClass:
                                    "mt-1 flex-grow flex flex-col justify-between",
                                },
                                [
                                  _c("dt", { staticClass: "sr-only" }, [
                                    _vm._v("Description"),
                                  ]),
                                  _vm._v(" "),
                                  _c(
                                    "dd",
                                    {
                                      staticClass:
                                        "text-gray-400 text-sm mx-6 description",
                                      attrs: { title: block.meta.description },
                                    },
                                    [
                                      _vm._v(
                                        _vm._s(block.meta.description) +
                                          "\n                                    "
                                      ),
                                    ]
                                  ),
                                  _vm._v(" "),
                                  _c("dt", { staticClass: "sr-only" }, [
                                    _vm._v("Role"),
                                  ]),
                                  _vm._v(" "),
                                  _c(
                                    "dd",
                                    { staticClass: "mt-3" },
                                    _vm._l(
                                      block.meta.tags,
                                      function (color, text) {
                                        return _c(
                                          "span",
                                          {
                                            staticClass:
                                              "px-2 mx-1 py-1 text-xs font-medium text-black rounded-full",
                                            class: color,
                                          },
                                          [
                                            _vm._v(
                                              "\n                                            " +
                                                _vm._s(text) +
                                                "\n                                        "
                                            ),
                                          ]
                                        )
                                      }
                                    ),
                                    0
                                  ),
                                ]
                              ),
                            ]
                          ),
                        ]
                      ),
                    ]
                  )
                }),
                0
              ),
            ])
          }),
          0
        ),
      ]),
    ]
  )
}
var staticRenderFns = [
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "pr-4" }, [
      _c("h4", { staticClass: "my-0" }, [_vm._v("Blok toevoegen")]),
      _vm._v(" "),
      _c("h6", { staticClass: "mt-1 mb-5" }, [
        _vm._v(
          "Kies een blok uit één van de categorieën en sleep deze links op de pagina om toe te voegen."
        ),
      ]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }